import React from "react";
import { Alert, Box, CircularProgress, Paper, Typography } from "@mui/material";
import {
	PAYMENT_METHOD_EXAMPLES,
	STARTER_ACCOUNTS,
	TENANT_RENT_COLLECTED_EXAMPLE,
} from "../constants";

const OverviewTab = ({ status, isLoadingStatus, sessionOrganization, requiresOrganizationSelection }) => {
	if (isLoadingStatus) {
		return (
			<Box display="flex" justifyContent="center" py={4}>
				<CircularProgress />
			</Box>
		);
	}

	return (
		<Box>
			{!requiresOrganizationSelection && sessionOrganization && (
				<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
					Organisation: <strong>{sessionOrganization.name}</strong>
					{sessionOrganization.code ? ` (${sessionOrganization.code})` : ""}
				</Typography>
			)}

			<Alert severity={status?.accounting_enabled ? "success" : "warning"} sx={{ mb: 3 }}>
				{status?.message ||
					(status?.accounting_enabled
						? "Accounting auto-posting is active."
						: "Accounting auto-posting is disabled.")}
			</Alert>

			<Typography variant="h6" gutterBottom>
				Setup order
			</Typography>
			<Box component="ol" sx={{ pl: 3, mb: 3 }}>
				<li>Create chart of accounts (one asset per rail: Cash, MTN, Airtel, Bank, Airtel Merchant)</li>
				<li>Map payment methods → accounts</li>
				<li>Create posting templates with &quot;Use payment method&quot; on the cash/wallet line</li>
				<li>New payments auto-post — use Event logs to debug failures</li>
				<li>Run Trial balance to verify books</li>
			</Box>

			<Typography variant="h6" gutterBottom>
				Suggested starter accounts (UGX)
			</Typography>
			<Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
				{STARTER_ACCOUNTS.map((row) => (
					<Typography key={row.code} variant="body2" sx={{ fontFamily: "monospace" }}>
						{row.code} — {row.name} ({row.account_type})
					</Typography>
				))}
			</Paper>

			<Typography variant="h6" gutterBottom>
				Payment method → account mapping
			</Typography>
			<Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
				{PAYMENT_METHOD_EXAMPLES.map((row) => (
					<Typography key={row.method} variant="body2">
						{row.method} → {row.account}
					</Typography>
				))}
			</Paper>

			<Typography variant="h6" gutterBottom>
				Example: tenant_rent_collected template
			</Typography>
			<Paper variant="outlined" sx={{ p: 2 }}>
				{TENANT_RENT_COLLECTED_EXAMPLE.map((line) => (
					<Typography key={`${line.side}-${line.code}`} variant="body2">
						{line.side} {line.code} — {line.amount_key}
						{line.uses_payment_method ? " (uses payment method)" : ""}
					</Typography>
				))}
			</Paper>
		</Box>
	);
};

export default OverviewTab;
